module.exports = __webpack_public_path__ + "static/media/spinner.78d9c34f.svg";